import stripHtmlFromString from 'src/utils/stripHtmlFromString';

const getUrlFromString = (text = '') => {
  const matched = text.match(/\bhttps?:\/\/[^"]+/gi);

  return matched ? matched[0] : null;
};

const getFlickrLicense = (licenseId: string | undefined) => {
  switch (licenseId) {
    case '4':
      return {
        name: 'CC BY 2.0',
        url: 'https://creativecommons.org/licenses/by/2.0/'
      };

    case '5':
      return {
        name: 'CC BY-SA 2.0',
        url: 'https://creativecommons.org/licenses/by-sa/2.0/'
      };

    case '6':
      return {
        name: 'CC BY-ND 2.0',
        url: 'https://creativecommons.org/licenses/by-nd/2.0/'
      };

    case '9':
      return {
        name: 'CC0 1.0',
        url: 'https://creativecommons.org/publicdomain/zero/1.0/'
      };

    case '10':
      return {
        name: 'Public Domain Mark',
        url: 'https://creativecommons.org/publicdomain/mark/1.0/'
      };

    default:
      return {
        name: 'CC BY 2.0',
        url: 'https://creativecommons.org/licenses/by/2.0/'
      };
  }
};

const unsplashUrl = 'https://unsplash.com';
const unsplashUtm = '?utm_source=Humbo&utm_medium=referral';

const descriptionClassName =
  'text-center opacity-60 max-w-[800px] line-clamp-3 [&_a]:font-semibold max-[800px]:line-clamp-5 max-[500px]:text-sm';

type Props = {
  image: PlaceImage;
  showImageDescription?: boolean;
};

const ImageDescription = ({image, showImageDescription = true}: Props) => {
  if (image.unsplashUser) {
    const photoDescription = (showImageDescription && image.description) || 'Photo';

    return (
      <span className={descriptionClassName}>
        {photoDescription} by{' '}
        <a
          href={`${unsplashUrl}/@${image.unsplashUser?.username}${unsplashUtm}`}
          target="_blank"
          rel="noreferrer external nofollow"
        >
          {' '}
          {image.unsplashUser?.name}
        </a>{' '}
        on{' '}
        <a href={`${unsplashUrl}/${unsplashUtm}`} target="_blank" rel="noreferrer external nofollow">
          Unsplash
        </a>
      </span>
    );
  }

  if (image.flickrUser) {
    const photoDescription = (showImageDescription && image.description) || 'Photo';
    const license = getFlickrLicense(image.flickrLicense);

    return (
      <span className={descriptionClassName}>
        {photoDescription} by{' '}
        <a
          href={`https://www.flickr.com/photos/${image.flickrUser}`}
          target="_blank"
          rel="noreferrer external nofollow"
        >
          {' '}
          {image.flickrUserName}
        </a>
        {license ? (
          <>
            , licenced under{' '}
            <a href={license.url} target="_blank" rel="noreferrer external nofollow">
              {license.name}
            </a>
          </>
        ) : null}{' '}
        on{' '}
        <a href="https://flickr.com" target="_blank" rel="noreferrer external nofollow">
          Flickr
        </a>
      </span>
    );
  }

  if (image.wikiArtist) {
    const imageName = showImageDescription && stripHtmlFromString(image.wikiObjectName);
    const artist = stripHtmlFromString(image.wikiArtist);
    const artistUrl = getUrlFromString(image.wikiArtist);

    return (
      <span className={descriptionClassName}>
        {image.originalUrl && imageName ? (
          <a href={image.originalUrl} target="_blank" rel="noreferrer external nofollow">
            "{imageName}"
          </a>
        ) : (
          imageName || 'Photo'
        )}{' '}
        by{' '}
        {artistUrl ? (
          <a href={artistUrl} target="_blank" rel="noreferrer external nofollow">
            {artist}
          </a>
        ) : (
          artist
        )}
        , licenced under{' '}
        <a href={image.wikiLicenseUrl} target="_blank" rel="noreferrer external nofollow">
          {image.wikiLicense}
        </a>
      </span>
    );
  }

  return <span className={descriptionClassName}>{image.description}</span>;
};

export default ImageDescription;
